import { useEffect } from 'react';
import { notificationService } from '../services/notificationService';

const dispatchUnreadCount = () => {
  notificationService.getUnreadCount().then(r => {
    if (r.success) {
      window.dispatchEvent(new CustomEvent('notifications:unread_count', {
        detail: { count: r.count }
      }));
    }
  });
};

export const useNotifications = () => {
  useEffect(() => {
    const authToken = localStorage.getItem('auth_token');
    if (!authToken) return;

    // Fetch initial unread count for the bell badge
    dispatchUnreadCount();

    // Refresh unread count when a new notification arrives
    // (toast + notifications:new event are handled by cableService._autoSubscribeNotifications)
    const handleNew = () => dispatchUnreadCount();
    window.addEventListener('notifications:new', handleNew);

    return () => {
      window.removeEventListener('notifications:new', handleNew);
    };
  }, []);
};
